document.querySelectorAll(".menopause_tab_content").forEach((tab, index) => {
   if (index === 0) {
      tab.style.display = "block"
   } else {
      tab.style.display = "none"
   }
})

document.querySelectorAll("ul.menopause_tabs li").forEach(function (tab) {
   tab.addEventListener("click", function () {
      document.querySelectorAll(".menopause_tab_content").forEach(function (content) {
         content.style.display = "none";
      });

      var activeTab = this.getAttribute("rel");

      document.getElementById(activeTab).style.display = "block";

      document.querySelectorAll("ul.menopause_tabs li").forEach(function (tab) {
         tab.classList.remove("active");
      });

      this.classList.add("active");

      document.querySelectorAll(".menopause_tab_drawer_heading").forEach(function (heading) {
         heading.classList.remove("d_active");
      });

     var tabHeading = document.querySelector(".menopause_tab_drawer_heading[rel^='" + activeTab + "']");
    if (tabHeading) {
        tabHeading.classList.add("d_active");
    } 

   });
});


document.querySelectorAll(".menopause_tab_drawer_heading").forEach(function (heading) {
   heading.addEventListener("click", function () {
      document.querySelectorAll(".menopause_tab_content").forEach(function (content) {
         content.style.display = "none";
      });

      var d_activeTab = this.getAttribute("rel");

      document.getElementById(d_activeTab).style.display = "block";

      document.querySelectorAll(".menopause_tab_drawer_heading").forEach(function (heading) {
         heading.classList.remove("d_active");
      });

      this.classList.add("d_active");

      document.querySelectorAll("ul.menopause_tabs li").forEach(function (tab) {
         tab.classList.remove("active");
      });

      document.querySelector("ul.menopause_tabs li[rel^='" + d_activeTab + "']").classList.add("active");
   });
});

document.querySelector("ul.menopause_tabs li:last-child").classList.add("tab_last");

document.querySelectorAll('.menopause_tabs .links').forEach(function(element) {
  let text = element.textContent;
  text = text.replace(/1/g, '');
  element.textContent = text;
});

